import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { CreateFormViewTopBar } from "./TopBar"

export const createFormViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: CreateFormViewTopBar,
}
